import NotificationEmptyStateIcon from "@icons/NotificationEmptyStateIcon";
import Colors from "@src/constants/Colors";

import {
  NotificationEmptyStateCard,
  NotificationEmptyStateText,
} from "./style";

const NotificationEmptyState = () => {
  return (
    <NotificationEmptyStateCard isNotification>
      <NotificationEmptyStateIcon />
      <div>
        <NotificationEmptyStateText
          fontFamilyBold
          color={Colors.neutral_gray_500}
        >
          You’re all caught up!
        </NotificationEmptyStateText>
        <NotificationEmptyStateText color={Colors.neutralblack}>
          Check this section for future updates.
        </NotificationEmptyStateText>
      </div>
    </NotificationEmptyStateCard>
  );
};

export default NotificationEmptyState;
